import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import PropTypes from 'prop-types';

export const ScrollTo = React.memo(({ children, page = '/', element, offset = 0, ...rest }) => {
  const navigate = useNavigate();

  const handleClick = useCallback(() => {
    navigate(page);
    setTimeout(() => {
      const el = document.querySelector(element);
      if (el) {
        const offsetTop = el.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: offsetTop, behavior: 'smooth' });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }, 100);
  }, [element, navigate, offset, page]);
  return (
    <div {...rest} onClick={handleClick}>
      {children}
    </div>
  );
});

ScrollTo.propTypes = {
  children: PropTypes.node.isRequired,
  page: PropTypes.string,
  element: PropTypes.string.isRequired,
  offset: PropTypes.number,
};
